/* eslint-disable no-param-reassign */
import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import FontKeys from '../FontKeys';

export default class PushButton extends Phaser.GameObjects.Container {
  constructor(scene, spritename, lblname, xoff, yoff, doUp) {
    super(scene);
    scene.add.existing(this);

    this.scene = scene;
    this.spritename = spritename;
    this.lblName = lblname;
    if (!xoff) xoff = 0;
    this.xOffset = xoff;
    if (!yoff) yoff = 0;
    this.yOffset = yoff;
    if (doUp === undefined) doUp = true;
    this.doUp = doUp;
    this.pushSize = 4;
    this.enabled = true;

    this.bg = ABCyaPhaser.Images.addImage(0, 0, `${this.spritename}_up`, this).setOrigin(0, 0);
    this.lbl = ABCyaPhaser.Images.addImage(0, 0, this.lblName, this).setOrigin(0, 0);
    if (this.lblName === 'Label_Repeat') {
      this.lblTxt = ABCyaPhaser.Text.addText(53,73, 18, 0xffffff, FontKeys._asapbold, ABCyaPhaser.Localization.instance.getLocalizedString('repeat_button'), this).setOrigin(0.5);
    }

    this.lblx = this.bg.getBounds().width / 2 - this.lbl.getBounds().width / 2 + this.xOffset;
    this.lbly = this.bg.getBounds().height / 2 - this.lbl.getBounds().height / 2 + this.yOffset;
    this.initLayout();

    this.bg.on('pointerdown', () => {this.onPress();});
    if (this.doUp) this.bg.on('pointerup', () => {this.onRelease();});
  }

  initLayout() {
    this.bg.setFrame(`${this.spritename}_up`);
    this.bg.x = 0;
    this.bg.y = 0;
    this.lbl.x = this.lblx;
    this.lbl.y = this.lbly;
    if (this.lblTxt) {
      this.lblTxt.x = 53;
      this.lblTxt.y = 73;
    }
  };

  onPress() {
    this.bg.setFrame(`${this.spritename}_down`);
    this.bg.x += this.pushSize;
    this.bg.y += this.pushSize;
    this.lbl.x += this.pushSize;
    this.lbl.y += this.pushSize;
    if (this.lblTxt) {
      this.lblTxt.x += this.pushSize;
      this.lblTxt.y += this.pushSize;
    }
  };

  onRelease() {
    this.initLayout();
    this.doUp();
  };
}